import React , {Fragment} from "react";
import shop from "shop/shop";
import { Button, Table } from "semantic-ui-react";
import languageStore from "stores/languageStore"

export function ProductManufactorerDownloads( { product } ) {
  let {locale} = languageStore
  console.log( "locale", locale )

  return (
    <div>
      {product.extras &&
        product.extras.Z_Hersteller &&
        product.extras.Z_Hersteller.value.value &&
        (
          product.extras.Z_Hersteller.value.value === "Forestadent" ||
          product.extras.Z_Hersteller.value.value === "G&H" ||
          product.extras.Z_Hersteller.value.value === "Ormco" ||
          product.extras.Z_Hersteller.value.value === "O2" ||
          product.extras.Z_Hersteller.value.value === "PSM Medical Solutions" ||
          product.extras.Z_Hersteller.value.value === "3M"
        ) && (
          <Fragment>
            <h4>
              {translate(
                ` Produktkatalog für ${
                  product.extras.Z_Hersteller.value.value === "Forestadent"
                    ? `Forestadent`
                    : product.extras.Z_Hersteller.value.value === "G&H"
                    ? `G&H Orthodontics`
                    : product.extras.Z_Hersteller.value.value === "Ormco"
                    ? `Ormco`
                    : product.extras.Z_Hersteller.value.value === "O2"
                    ? `O2 Ortho Organizers`
                    : product.extras.Z_Hersteller.value.value === "PSM Medical Solutions"
                    ? `PSM Medical Solutions`
                    : product.extras.Z_Hersteller.value.value === "3M"
                    ? `3M Orthodontics`
                    : ""
                }`
              )}
            </h4>
            <Table basic="very">
              <Table.Body>
                <Table.Row>
                  <Table.Cell style={{ padding: 0 }}>
                    <Button
                      style={{
                        width: "250px",
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                      }}
                      primary
                      size="tiny"
                      as="a"
                      target="_blank"
                      download={translate(`Katalog jetzt herunterladen `)}
                      href={
                        product.extras.Z_Hersteller.value.value === "Forestadent"
                          ? `https://www.healthcare-holding.ch/hubfs/04_Ortho%20Walker%20Files/0406_Hersteller%20Kataloge/Forestadent_Katalog_No_37_DE_EN.pdf?hsLang=${"de"}`
                          : product.extras.Z_Hersteller.value.value === "G&H"
                          ? `https://www.healthcare-holding.ch/hubfs/GH_Catalogue_Vol_16_EN.pdf?hsLang=de`
                          : product.extras.Z_Hersteller.value.value === "Ormco"
                          ? `https://www.healthcare-holding.ch/hubfs/04_Ortho%20Walker%20Files/0406_Hersteller%20Kataloge/Ormco_Catalogue_2022_EN.pdf?hsLang=de`
                          : product.extras.Z_Hersteller.value.value === "O2"
                          ? `https://www.healthcare-holding.ch/hubfs/04_Ortho%20Walker%20Files/0406_Hersteller%20Kataloge/O2_OrthoOrganizer_Catalog_SLX_Clear_Aligners_EN.pdf?hsLang=de`
                          : product.extras.Z_Hersteller.value.value === "PSM Medical Solutions"
                          ? `https://www.healthcare-holding.ch/hubfs/04_Ortho%20Walker%20Files/0406_Hersteller%20Kataloge/PSM_Kataloge_2023_EN.pdf?hsLang=de`
                          : product.extras.Z_Hersteller.value.value === "3M"
                          ? `https://www.healthcare-holding.ch/hubfs/04_Ortho%20Walker%20Files/0406_Hersteller%20Kataloge/Solventum_3M_OralCare_Ortho_Catalog_2020_EN.pdf?hsLang=de`
                          : ""
                      }
                    >
                      <span className="fw6 f5" style={{ width: "100%", textAlign: "center" }}>
                        {translate(`Katalog jetzt herunterladen `)}
                      </span>
                    </Button>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Fragment>
        )}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/theme/ortho-test/components/ProductManufactorerDownloads.js